import { IonItem, IonLabel } from '@ionic/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Machine, useListMachinesQuery } from '../../../api/graphql/generated';
import { IntercomArticle } from '../../../config/intercom';
import { useBeaconRouter } from '../../../route/route.hooks';
import { IntercomHelp } from '../../help/intercom-help';
import { HBIonItemProps } from '../../ionic/IonItem';
import { ObjectList, RowRenderer } from '../../object/object-list';
import { DateField } from '../../ui/date-field';

interface InactiveMachinePickerProps {
  teamId: string;
  onSelect: () => void;
}

const InactiveMachinePicker = (props: InactiveMachinePickerProps) => {
  const { teamId, onSelect } = props;
  const { i18n } = useTranslation();

  const { builder } = useBeaconRouter();

  const rowRenderer = useCallback<RowRenderer<Machine>>(
    ({ item: machine }) => {
      let itemProps: HBIonItemProps = {};

      itemProps = {
        detail: true,
        routerLink: builder.getMachineDetailsRoute(machine.teamId, machine.id, {
          queryParams: {
            reactivate: true,
          },
        }),
        onClick: () => {
          onSelect();
        },
      };
      return (
        <IonItem key={machine.id} {...itemProps}>
          <IonLabel>
            <h2>{machine.name}</h2>
            <p>
              {`${i18n.t('common:last_activity')}: `}
              <DateField date={machine?.state?.updatedAt} />
            </p>
          </IonLabel>
        </IonItem>
      );
    },
    [onSelect, builder, i18n]
  );

  return (
    <>
      <ObjectList
        query={{
          useQuery: useListMachinesQuery,
          queryOptions: {
            // Note: Using cache-only prevents gql ui components from subscribing to the cache. See https://github.com/apollographql/apollo-client/issues/5239
            fetchPolicy: 'network-only',
          },
          input: {
            teamId,
            active: false,
          },
        }}
        rowRenderer={rowRenderer}
      />
      <IntercomHelp
        articleId={IntercomArticle.MANAGING_ROBOTS}
        description={i18n.t('common:machine_learn_about_managing_machines')}
      />
    </>
  );
};

export { InactiveMachinePicker };
